module.exports = __webpack_public_path__ + "media/images/avatar-d9585c8b5624f26a266ee191343e4566.png";